import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik, FormikProvider } from "formik";
import { addMonths, format, subDays } from "date-fns";
import CurrencyInput from "react-currency-input-field";
import * as Yup from "yup";
import {
  Box,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Tab,
  Tabs,
  Button,
  Grid,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Edit } from "@mui/icons-material";

import { ContratoTab } from "../../contratoTab";
import { ServicoTab } from "../../servicoTab";

import { MyContext } from "../../../../../Context/MyContext";
import {
  BoxBase,
  CheckboxBase,
  CustomTabPanel,
  FormControlBase,
  FormSectionBox,
  FormSectionTitle,
  SelectBase,
  TextFieldBase,
  ButtonBase,
  InputLabelSelect,
  tabProps,
} from "../../../styles";
import { PedidosContext } from "../../../../../Context/PedidosContext";
import { ModalLiberacao } from "../../modalLiberacao";
import Loading from "../../../../../Components/Loading";
import Mensagem from "../../../../../Components/Mensagem";
import ModalNS from "../../../../../Components/ModalNS";
import api from "../../../../../Api/apiAxios";
import { LicencaSection } from "../../licencaSection";

export function PedidoAcesso({ isShow = false }) {
  const [value, setValue] = useState(0);
  const [tiposServico, setTiposServico] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [listaNS, setListaNS] = useState([]);
  const [selectedNS, setSelectedNS] = useState(false);
  const [showModalNS, setShowModalNS] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showMensagem, setShowMensagem] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState("");
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [versoesAcesso, setVersoesAcesso] = useState([]);
  const [isLicenciadoEnabled, setIsLicenciadoEnabled] = useState(false);
  const [lastLicenca, setLastLicenca] = useState({});
  const [isRevendaEnabled, setIsRevendaEnabled] = useState(true);

  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(false);
  const [isAdicionaisDisabled, setIsAdicionaisDisabled] = useState(false);
  const [isModComercializacaoDisabled, setIsModComercializacaoDisabled] = useState(false);
  const [isModServicoDisabledAcessoGo, setIsModServicoDisabledAcessoGo] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const isSavingRef = useRef(false);

  const currencyFormatter = useMemo(
    () => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }),
    []
  );
  const [valorDiferencaMensal, setValorDiferencaMensal] = useState(currencyFormatter.format(0));
  const [valorContratoSituacao, setValorContratoSituacao] = useState(0);

  const nivelUsuario = window.localStorage.getItem("nivelUsuario");
  const idDistribuidor = window.localStorage.getItem("distribuidorId");

  const { id } = useParams();
  const { setMensagemGlobal, setTipoMensagemGlobal } = useContext(MyContext);
  const {
    distribuidores,
    modalLiberacao,
    setModalLiberacao,
    setDadosTabs,
    motivosCancelamento,
    setPedidoLiberado,
    pedidoLiberado,
    parseNumberCurrency,
    getDistribuidores,
    tipoServicoPadrao,
  } = useContext(PedidosContext);

  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  async function buscarValorContratoAtual(numeroSerie) {
    if (!numeroSerie || numeroSerie === 0 || numeroSerie === "0") return 0;

    try {
      const { data } = await api.get(
        `/Contrato/retornar-situacao-contrato?numeroSerie=${numeroSerie}&sistema=ACESSO`
      );
      
      return Number(data?.valorAtual) || 0;
    } catch (error) {
      try {
        const { data } = await api.get(`/Contrato/retornar-situacao-contrato?numeroSerie=${numeroSerie}`);
        return Number(data?.valor) || 0;
      } catch {
        return 0;
      }
    }
  }

  const validationSchema = Yup.object().shape({
    tipoPedido: Yup.number().nullable(),
    numeroSerie: Yup.string().required("Número de Série é obrigatório"),
    dataValidade: Yup.date().nullable(),
    distribuidor: Yup.number().required("Revenda é obrigatória"),
    cliente: Yup.number().required("Cliente é obrigatório"),
    razaoSocial: Yup.string().nullable(),
    nomeFantasia: Yup.string().nullable(),
    numeroInscricao: Yup.string().nullable(),
    observacoes: Yup.string().max(255, "Observações devem ter no máximo 255 caracteres").nullable(),
    bancoDeDados: Yup.string().required("Banco de Dados é obrigatório"),
    tipoPlano: Yup.number().nullable(),
    vertical: Yup.number().required("Vertical é obrigatória"),
    versao: Yup.string().nullable(),
    release: Yup.string().nullable(),
    serverAdicional: Yup.number().typeError("Server Adicional deve ser um número").nullable(),
    equipamentosAdicionais: Yup.number().typeError("Equipamentos Adicionais deve ser um número").nullable(),
    usuariosAgenda: Yup.number().typeError("Usuários Agenda deve ser um número").nullable(),
    alunos: Yup.boolean().required("Este campo é obrigatório"),
    funcionarios: Yup.boolean().required("Este campo é obrigatório"),
    pacientes: Yup.boolean().required("Este campo é obrigatório"),
    moduloLGPD: Yup.boolean().required("Este campo é obrigatório"),
    ponto: Yup.boolean().required("Este campo é obrigatório"),
    portalTerceiros: Yup.boolean().required("Este campo é obrigatório"),
    portalTreinamento: Yup.boolean().required("Este campo é obrigatório"),
    contrato: Yup.boolean().required("Este campo é obrigatório"),
    valorLicenca: Yup.string().nullable(),
    valorModuloLGPD: Yup.string().nullable(),
    valorEquipAdicional: Yup.string().nullable(),
    valorServerAdicional: Yup.string().nullable(),
    totalPedido: Yup.string().nullable(),
    valorMensal: Yup.string().nullable(),
    valorModulosIntegracoes: Yup.string().nullable(),
    statusPedido: Yup.number().nullable(),
    dataCancelamento: Yup.date()
      .nullable()
      .min(subDays(new Date(), 1), "A data de cancelamento deve ser a partir de hoje."),
    motivoCancelamentoOpcao: Yup.number().nullable(),
    motivoCancelamento: Yup.string().nullable(),
    quantidadeLicencas: Yup.number().nullable(),
    modalidadeComercializacao: Yup.number()
      .required("Modalidade de comercialização é obrigatória")
      .oneOf([2], 'A modalidade de comercialização deve ser "Locação" para novos cadastros.'),
    tipoLicenciamento: Yup.number().nullable(),
    modalidadeServico: Yup.number().required("Modalidade de serviço é obrigatória"),
    pontoSaas: Yup.boolean().required("Este campo é obrigatório"),
    dataLiberacao: Yup.date().nullable(),
    tipoServicoId: Yup.number().nullable().required('Tipo de Serviço é obrigatório'),
    observacaoNotaFiscal: Yup.string().nullable().max(1000, 'Observação de Nota Fiscal não pode ter mais de 1000 caracteres'),
  });

  const formik = useFormik({
    initialValues: {
      tipoPedido: 0,
      numeroSerie: 0,
      dataValidade: null,
      distribuidor: null,
      cliente: null,
      nomeFantasia: "",
      observacoes: "",
      bancoDeDados: null,
      tipoPlano: 1,
      vertical: null,
      versao: 0,
      release: 0,
      versaoFormatada: "0.00.000",
      serverAdicional: 0,
      equipamentosAdicionais: 0,
      usuariosAgenda: 0,
      alunos: false,
      funcionarios: false,
      pacientes: false,
      moduloLGPD: false,
      ponto: false,
      portalTerceiros: false,
      portalTreinamento: false,
      contrato: true,
      valorLicenca: "0,00",
      valorModuloLGPD: "0,00",
      valorEquipAdicional: "0,00",
      valorServerAdicional: "0,00",
      valorModulosIntegracoes: "0,00",
      totalPedido: "0,00",
      valorMensal: "0,00",
      statusPedido: 0,
      dataCancelamento: null,
      motivoCancelamentoOpcao: 0,
      motivoCancelamento: "",
      quantidadeLicencas: 0,
      modalidadeComercializacao: 2,
      tipoLicenciamento: 2,
      modalidadeServico: 1,
      pontoSaas: false,
      dataLiberacao: null,
      tipoServicoId: null,
      observacaoNotaFiscal: '',
    },
    validationSchema: validationSchema,
    onSubmit: async () => {
      if (isSavingRef.current) return;
      isSavingRef.current = true;
      setIsSaving(true);
      try {
        await handleSave();
      } finally {
        setIsSaving(false);
        isSavingRef.current = false;
      }
    },
  });

  const handleSave = async (values) => {
    setMensagemGlobal("");
    setTipoMensagemGlobal("");
    setShowMensagem(false);

    if (nivelUsuario !== "1") await handleVerificarTotaisClick();

    const tipoInstalacao = 0;

    let diferencaValorMensalUltimaLicenca = 0;
    if (formik.values.tipoPedido === 1 && lastLicenca && Object.keys(lastLicenca).length > 0) {
      const valorAtual = parseNumberCurrency(formik.values.valorMensal) || 0;
      const referenciaContrato = valorContratoSituacao || 0;
      diferencaValorMensalUltimaLicenca = valorAtual - referenciaContrato;
    }

    let regPedido = {
      Id: id || 0,
      TipoVertical: formik.values.vertical,
      EquipamentoAdicional: formik.values.equipamentosAdicionais || 0,
      ValorEquipamentoAdicional: parseNumberCurrency(formik.values.valorEquipAdicional),
      ServerAdicional: formik.values.serverAdicional || 0,
      ValorServerAdicional: parseNumberCurrency(formik.values.valorServerAdicional),
      AgendaWeb: formik.values.usuariosAgenda > 0 ? 1 : 0,
      UsuariosAgenda: formik.values.usuariosAgenda || 0,
      IntegracaoFuncionarios: formik.values.funcionarios ? 1 : 0,
      IntegracaoPacientes: formik.values.pacientes ? 1 : 0,
      ModuloLGPD: formik.values.moduloLGPD ? 1 : 0,
      ValorModuloLGPD: parseNumberCurrency(formik.values.valorModuloLGPD),
      DistribuidorId: formik.values.distribuidor,
      TipoPedido: formik.values.tipoPedido,
      ClienteId: formik.values.cliente,
      NumeroSerie: formik.values.numeroSerie,
      StatusPedido: 0,
      TipoBancoDados: formik.values.bancoDeDados,
      TipoInstalacao: tipoInstalacao,
      TipoComercializacao: formik.values.modalidadeComercializacao,
      TipoLicenciamento: formik.values.modalidadeComercializacao === 1 ? formik.values.tipoLicenciamento : 2,
      TipoServicoPedido: formik.values.modalidadeServico,
      VersaoSistema: formik.values.versao?.toString().includes(".")
        ? formik.values.versao
        : formik.values.versao.toString().substring(0, 1) +
          (formik.values.versao.toString().substring(1).length > 0
            ? "." + formik.values.versao.toString().substring(1)
            : ""),
      VersaoRelease: formik.values.release ? formik.values.release.toString() : "",
      DataPedido: new Date().toISOString(),
      Observacao: formik.values.observacoes || "",
      MotivoCancelamento: "",
      NumeroOrdemCompra: "",
      ValorBruto: parseNumberCurrency(formik.values.totalPedido),
      ValorDesconto: 0,
      ValorLiquido: parseNumberCurrency(formik.values.totalPedido),
      ValorMensal: parseNumberCurrency(formik.values.valorMensal),
      DiferencaValorMensalUltimaLicenca: diferencaValorMensalUltimaLicenca,
      ValorLicenca: parseNumberCurrency(formik.values.valorLicenca),
      ValorModulosIntegracoes: parseNumberCurrency(formik.values.valorModulosIntegracoes),
      IntegracaoAcesso: 0,
      IntegracaoFolha: 0,
      IntegracaoPonto: formik.values.ponto ? 1 : 0,
      Contrato: formik.values.contrato ? 1 : 0,
      IntegracaoAlunos: formik.values.alunos ? 1 : 0,
      Locacao: formik.values.tipoComercializacao === 2 ? 1 : 0,
      PortalTerceiros: formik.values.portalTerceiros ? 1 : 0,
      PortalTreinamento: formik.values.portalTreinamento ? 1 : 0,
      DataCancelamento: formik.values.dataCancelamento,
      motivoCancelamentoOpcao: formik.values.motivoCancelamentoOpcao,
      motivoCancelamento: formik.values.motivoCancelamento,
      PontoSaas: formik.values.pontoSaas ? 1 : 0,
      CopiaDemonstracao: 0,
      EnviarEmailPedidoLiberado: 0,
      TipoServicoId: formik.values.tipoServicoId,
      ObservacaoNotaFiscal: formik.values.observacaoNotaFiscal || null,
    };

    if (formik.values.dataValidade !== null) {
      regPedido = { ...regPedido, DataValidade: formik.values.dataValidade };
    }

    try {
      let ret;

      if (id) {
        ret = await api.put("/BmaAcesso/", JSON.stringify(regPedido), {
          headers: { "Content-Type": "application/json" },
        });
      } else {
        ret = await api.post("/BmaAcesso/", JSON.stringify(regPedido), {
          headers: { "Content-Type": "application/json" },
        });
      }

      if (!id && ret.data.id > 0) {
        setMensagem("Pedido incluído com sucesso!");
        setTipoMensagem("success");
        setShowMensagem(true);
        navigate(`/viewpedidoacesso/${ret.data.id}`);
      } else if (id) {
        setMensagem("Pedido alterado com sucesso!");
        setTipoMensagem("success");
        setShowMensagem(true);
        navigate(`/viewpedidoacesso/${ret.data.id}`);
      }
    } catch (error) {
      console.error(error);
      setMensagem(error);
      setTipoMensagem("danger");
      setShowMensagem(true);
    }
  };

  const handleSelecionarNS = async () => {
    if (formik.values.tipoPedido !== 1) formik.setFieldValue("tipoPedido", 1);
    setSelectedNS(false);

    await loadNumeroSerie(formik.values.cliente, true);

    if (listaNS.length > 0) setShowModalNS(true);
  };

  async function loadNumeroSerie(clienteId, load) {
    const res = await api.get(`/LicencaAcesso/retornar-ns-cliente?id=${clienteId}`);
    const qtdRegistros = res.data.length;
    formik.setFieldValue("quantidadeLicencas", qtdRegistros);

    if (load && qtdRegistros === 1) {
      const licenca = res.data[0];
      setLastLicenca(licenca);
      if (licenca?.tipoInstalacao === 0) formik.setFieldValue("tipoLicenciamento", 1);
      formik.setFieldValue("tipoPedido", 1);

      setSelectedNS(false);

      loadFields(licenca, true, true);
    } else if (qtdRegistros > 1) {
      setListaNS(res.data);
    } else if (formik.values.tipoPedido === 1) {
      formik.setFieldValue("tipoPedido", 0);
    }
  }

  async function handleDistribuidorChange(e) {
    formik.handleChange(e);
    formik.setFieldValue("cliente", 0);
    formik.setFieldValue("nomeFantasia", "");
    formik.setFieldValue("numeroSerie", 0);
    setListaNS([]);
  }

  async function handleClienteChange(e) {
    formik.handleChange(e);
    formik.setFieldValue("nomeFantasia", "");
    formik.setFieldValue("numeroSerie", 0);
    setListaNS([]);

    const idCliente = e.target.value;

    const response = await api.get(`/Cliente/${idCliente}`);

    formik.setFieldValue("nomeFantasia", response.data.nomeFantasia);
    formik.setFieldValue("numeroInscricao", response.data.numeroInscricao);

    loadNumeroSerie(response.data.id, formik.values.tipoPedido === 1);
  }

  useEffect(() => {
    const fetchContratoSituacao = async () => {
      const numeroSerie = lastLicenca?.numeroSerie;

      if (!numeroSerie) {
        setValorContratoSituacao(0);
        return;
      }

      const valor = await buscarValorContratoAtual(numeroSerie);
      setValorContratoSituacao(valor);
    };

    fetchContratoSituacao();
  }, [lastLicenca?.numeroSerie]);

  useEffect(() => {
    if (
      nivelUsuario !== "1" ||
      formik.values.tipoPedido !== 1 ||
      !lastLicenca ||
      Object.keys(lastLicenca).length === 0
    ) {
      setValorDiferencaMensal(currencyFormatter.format(0));
      return;
    }

    const valorAtual = parseNumberCurrency(formik.values.valorMensal) || 0;
    const referenciaContrato = valorContratoSituacao;

    const diferenca = valorAtual - referenciaContrato;
    setValorDiferencaMensal(currencyFormatter.format(diferenca));
  }, [
    currencyFormatter,
    formik.values.tipoPedido,
    formik.values.valorMensal,
    lastLicenca,
    nivelUsuario,
    parseNumberCurrency,
    valorContratoSituacao,
  ]);

  async function handleVerticalChange(e) {
    formik.handleChange(e);
    const selectedVertical = e.target.value;
    await atualizarVersaoPorVertical(selectedVertical);

    if (selectedVertical === 7) {
      setIsCheckboxDisabled(true);
      setIsAdicionaisDisabled(true);
      setIsModComercializacaoDisabled(true);
      setIsModServicoDisabledAcessoGo(true);

      formik.setFieldValue("alunos", false);
      formik.setFieldValue("funcionarios", false);
      formik.setFieldValue("pacientes", false);
      formik.setFieldValue("moduloLGPD", false);
      formik.setFieldValue("ponto", false);
      formik.setFieldValue("portalTerceiros", false);
      formik.setFieldValue("portalTreinamento", false);
      formik.setFieldValue("contrato", true);

      formik.setFieldValue("modalidadeComercializacao", 2);
      formik.setFieldValue("modalidadeServico", 1);

      formik.setFieldValue("serverAdicional", 0);
      formik.setFieldValue("equipamentosAdicionais", 0);
      formik.setFieldValue("usuariosAgenda", 0);
    } else {
      setIsCheckboxDisabled(false);
      setIsAdicionaisDisabled(false);
      setIsModComercializacaoDisabled(false);
      setIsModServicoDisabledAcessoGo(false);
    }
  }

  async function atualizarVersaoPorVertical(tipoVertical) {
    const response = await api.get(`/Versao/retornar-versao-atual?tipoSistema=2&tipoVertical=${tipoVertical}`);

    formik.setFieldValue("versao", response.data.numeroVersao);
    formik.setFieldValue("release", response.data.release);
    formik.setFieldValue("versaoFormatada", response.data.versaoCompletaEditada);
  }

  async function atualizarLicencaPorNS(fromBlur) {
    const { numeroSerie } = formik.values;

    if (!numeroSerie || numeroSerie === 0 || numeroSerie === "0") {
      formik.setFieldValue("tipoPedido", 0);
      return;
    }

    const { data } = await api.get(
      `/LicencaAcesso/parametros-consulta?id=${idDistribuidor}&nivel=${nivelUsuario}&tipo=ns&args=${numeroSerie}`
    );

    const licenca = data.reduce((maior, atual) => (atual.id > (maior?.id || 0) ? atual : maior), null);

    if (!licenca) return;

    const valorContratoAtual = await buscarValorContratoAtual(licenca.numeroSerie);

    setLastLicenca(licenca);
    setIsLicenciadoEnabled(
      licenca?.tipoInstalacao === 0 &&
        valorContratoAtual > 0 &&
        (!licenca?.tipoComercializacao || licenca?.tipoComercializacao === 1)
    );
    if (licenca?.tipoInstalacao === 0) formik.setFieldValue("tipoLicenciamento", 1);
    formik.setFieldValue("tipoPedido", 1);

    setSelectedNS(false);

    loadFields(licenca, fromBlur, true);

    await atualizarVersaoPorVertical(licenca.tipoVertical);
  }

  async function handleVerificarTotaisClick() {
    setIsSaveEnabled(true);

    const dataAtual = new Date();
    const tipoInstalacao = 0;

    let regPedido = {
      Id: id || 0,
      TipoVertical: formik.values.vertical,
      EquipamentoAdicional: formik.values.equipamentosAdicionais,
      ValorEquipamentoAdicional: parseNumberCurrency(formik.values.valorEquipAdicional),
      ServerAdicional: formik.values.serverAdicional,
      ValorServerAdicional: parseNumberCurrency(formik.values.valorServerAdicional),
      AgendaWeb: formik.values.usuariosAgenda > 0 ? 1 : 0,
      UsuariosAgenda: formik.values.usuariosAgenda,
      IntegracaoFuncionarios: formik.values.funcionarios ? 1 : 0,
      IntegracaoPacientes: formik.values.pacientes ? 1 : 0,
      ModuloLGPD: formik.values.moduloLGPD ? 1 : 0,
      ValorModuloLGPD: parseNumberCurrency(formik.values.valorModuloLGPD),
      DistribuidorId: formik.values.distribuidor,
      TipoPedido: formik.values.tipoPedido !== 2 ? formik.values.tipoPedido : 0,
      ClienteId: formik.values.cliente,
      NumeroSerie: formik.values.numeroSerie,
      StatusPedido: 0,
      TipoBancoDados: formik.values.bancoDeDados,
      TipoInstalacao: tipoInstalacao,
      TipoComercializacao: formik.values.modalidadeComercializacao,
      TipoLicenciamento: formik.values.tipoLicenciamento,
      TipoServicoPedido: formik.values.modalidadeServico,
      VersaoSistema: formik.values.versao.toString().includes(".")
        ? formik.values.versao
        : formik.values.versao.toString().substring(0, 1) +
          (formik.values.versao.toString().substring(1).length > 0
            ? "." + formik.values.versao.toString().substring(1)
            : ""),
      VersaoRelease: formik.values.release ? formik.values.release.toString() : "000",
      DataPedido: dataAtual.toISOString(),
      Observacao: formik.values.observacoes || "",
      MotivoCancelamento: "",
      NumeroOrdemCompra: "",
      ValorBruto: 0,
      ValorDesconto: 0,
      ValorLiquido: 0,
      ValorMensal: 0,
      ValorModulosIntegracoes: 0,
      IntegracaoAcesso: 0,
      IntegracaoFolha: 0,
      IntegracaoPonto: formik.values.ponto ? 1 : 0,
      Contrato: formik.values.contrato ? 1 : 0,
      IntegracaoAlunos: formik.values.alunos ? 1 : 0,
      Locacao: formik.values.tipoComercializacao === 2 ? 1 : 0,
      PortalTerceiros: formik.values.portalTerceiros ? 1 : 0,
      PortalTreinamento: formik.values.portalTreinamento ? 1 : 0,
      PontoSaas: formik.values.pontoSaas ? 1 : 0,
      ValorLicenca: 0,
      CopiaDemonstracao: 0,
      EnviarEmailPedidoLiberado: 0,
    };

    if (formik.values.dataValidade !== "" && formik.values.tipoComercializacao === 2) {
      regPedido = { ...regPedido, DataValidade: formik.values.dataValidade };
    }

    const calculoUrl =
      (regPedido.TipoComercializacao === 1 && regPedido.TipoLicenciamento === 2) || regPedido.Licenciado === 1
        ? "CalculoAcesso/2024"
        : "CalculoAcesso/2025";
    const ret = await api.post(calculoUrl, JSON.stringify(regPedido), { headers: { "Content-Type": "application/json" } });

    formik.setFieldValue("valorLicenca", ret.data.valorLicenca);
    formik.setFieldValue("valorEquipAdicional", ret.data.valorEquipamentoAdicional);
    formik.setFieldValue("valorServerAdicional", ret.data.valorServerAdicional);
    formik.setFieldValue("valorModuloLGPD", ret.data.valorModuloLGPD);
    formik.setFieldValue("valorModulosIntegracoes", ret.data.valorModulosIntegracoes);
    formik.setFieldValue("totalPedido", ret.data.valorBruto);
    formik.setFieldValue("valorMensal", ret.data.valorMensal);
  }

  const handleVersaoChange = (e) => {
    formik.handleChange(e);

    const [mainVersionParts, releaseParts] = e.target.value.split(".").reduce(
      (acc, part, index) => {
        if (index < 2) {
          acc[0].push(part);
        } else {
          acc[1].push(part);
        }
        return acc;
      },
      [[], []]
    );

    const major = mainVersionParts[0] || "0";
    let minor = mainVersionParts[1] || "0";

    minor = parseInt(minor, 10).toString();

    const mainVersion = `${major}.${minor}`;
    const release = releaseParts.join("") || "000";

    formik.setFieldValue("versao", mainVersion);
    formik.setFieldValue("release", release);
  };

  const loadFields = async (values, allFields, fromNS = false) => {
    const valorContratoAtual = await buscarValorContratoAtual(values.numeroSerie);

    if (allFields) {
      if (!fromNS) formik.setFieldValue("tipoPedido", values.tipoPedido);
      if (values.dataValidade) formik.setFieldValue("dataValidade", format(new Date(values.dataValidade), "yyyy-MM-dd"));
      formik.setFieldValue("distribuidor", values.distribuidorId);
      formik.setFieldValue("observacoes", values.observacao);
      formik.setFieldValue("valorMensal", values.valorMensal || valorContratoAtual || 0);
      formik.setFieldValue("valorEquipAdicional", values.valorEquipamentoAdicional || 0);
      formik.setFieldValue("valorServerAdicional", values.valorServerAdicional || 0);
      formik.setFieldValue("valorModuloLGPD", values.valorModuloLGPD || 0);
      formik.setFieldValue("valorLicenca", values.valorLicenca || 0);
      formik.setFieldValue("valorModulosIntegracoes", values.valorModulosIntegracoes || 0);
      formik.setFieldValue("totalPedido", values.valorBruto || 0);
      formik.setFieldValue("statusPedido", values.statusPedido);
      formik.setFieldValue("cliente", values.clienteId);

      await loadCliente(values);
    }

    formik.setFieldValue("numeroSerie", values.numeroSerie);
    formik.setFieldValue("bancoDeDados", values.tipoBancoDados);
    formik.setFieldValue("vertical", values.tipoVertical);
    formik.setFieldValue("usuariosAgenda", values.usuariosAgenda);
    formik.setFieldValue("equipamentosAdicionais", values.equipamentoAdicional);
    formik.setFieldValue("serverAdicional", values.serverAdicional);
    formik.setFieldValue("contrato", isShow ? values.temContrato === 1 || values.contrato === 1 : true);
    formik.setFieldValue("ponto", values.integracaoPonto === 1);
    formik.setFieldValue("moduloLGPD", values.moduloLGPD === 1);
    formik.setFieldValue("funcionarios", values.integracaoFuncionarios === 1);
    formik.setFieldValue("pacientes", values.integracaoPacientes === 1);
    formik.setFieldValue("alunos", values.integracaoAlunos === 1);
    formik.setFieldValue("portalTerceiros", values.portalTerceiros === 1);
    formik.setFieldValue("portalTreinamento", values.portalTreinamento === 1);
    formik.setFieldValue("motivoCancelamentoOpcao", values.motivoCancelamentoOpcao);
    formik.setFieldValue("pontoSaas", values.pontoSaas);
    formik.setFieldValue("motivoCancelamento", values.motivoCancelamento);
    formik.setFieldValue("tipoServicoId", values.tipoServicoId ?? null);
    formik.setFieldValue("observacaoNotaFiscal", values.observacaoNotaFiscal || '');

    if (values.dataCancelamento) formik.setFieldValue("dataCancelamento", format(new Date(values.dataCancelamento), "yyyy-MM-dd"));
    if (values.dataLiberacao) formik.setFieldValue("dataLiberacao", format(new Date(values.dataLiberacao), "yyyy-MM-dd"));

    if (fromNS) {
      const versoesDisponiveis = await loadVersoesAcesso(values.tipoVertical);

      formik.setFieldValue("versaoFormatada", versoesDisponiveis[0].versaoCompletaEditada);
      formik.setFieldValue("versao", versoesDisponiveis[0].numeroVersao);
      formik.setFieldValue("release", versoesDisponiveis[0].release);
    } else {
      formik.setFieldValue("versao", values.versaoSistema || values.versao);
      formik.setFieldValue("release", values.versaoRelease || values.release);

      formik.setFieldValue(
        "versaoFormatada",
        values.versao ||
          (() => {
            let versao = values.versaoSistema || values.versao;
            const release = values.versaoRelease || values.release;

            if (versao.includes(".") && versao?.split(".").length === 2) {
              const [major, minor] = versao.split(".");
              versao = `${major}.${minor.padStart(2, "0")}`;
            }

            return `${versao}.${release}`;
          })()
      );
    }

    await loadModalidades({ ...values, valorContratoAtual });
  };

  const loadModalidades = async (fields) => {
    if (fields.tipoComercializacao !== null) {
      setFieldsFromTipoComercializacao(fields);
    } else {
      const config = getModalidadeConfig(fields);
      setFieldsFromConfig(config);
    }
  };

  const setFieldsFromTipoComercializacao = (fields) => {
    formik.setFieldValue("modalidadeComercializacao", isShow ? fields.tipoComercializacao : 2);
    formik.setFieldValue("modalidadeServico", fields.tipoServicoPedido);
    formik.setFieldValue("tipoLicenciamento", fields.tipoLicenciamento);
    formik.setFieldValue("tipoPlano", fields.tipoInstalacao);
  };

  const getModalidadeConfig = (fields) => {
    const valorContratoAtual = Number(fields.valorContratoAtual) || 0;

    const config = {
      [null]: {
        modalidadeComercializacao: isShow ? (fields.locacao === 1 ? 2 : 1) : 2,
        modalidadeServico: 1,
        tipoLicenciamento: valorContratoAtual > 0 ? 2 : 1,
        tipoPlano: fields.tipoInstalacao,
      },
      0: {
        modalidadeComercializacao: isShow ? (fields.locacao === 1 ? 2 : 1) : 2,
        modalidadeServico: 1,
        tipoLicenciamento: valorContratoAtual > 0 ? 2 : 1,
        tipoPlano: fields.tipoInstalacao,
      },
      1: {
        modalidadeComercializacao: 2,
        modalidadeServico: 1,
        tipoPlano: fields.tipoInstalacao,
      },
      2: {
        modalidadeComercializacao: 2,
        modalidadeServico: 1,
        tipoPlano: fields.tipoInstalacao,
      },
    };

    return config[fields.tipoInstalacao];
  };

  const setFieldsFromConfig = (config) => {
    Object.keys(config).forEach((field) => {
      formik.setFieldValue(field, config[field]);
    });
  };

  const loadCliente = async (fields) => {
    if (fields.cliente) {
      formik.setFieldValue("nomeFantasia", fields.cliente.nomeFantasia);
      formik.setFieldValue("razaoSocial", fields.cliente.razaoSocial);
      formik.setFieldValue("numeroInscricao", fields.cliente.numeroInscricao);
    } else {
      const responseCliente = await api.get(`/Cliente/${fields.clienteId}`);

      formik.setFieldValue("nomeFantasia", responseCliente.data.nomeFantasia);
      formik.setFieldValue("numeroInscricao", responseCliente.data.numeroInscricao);
      formik.setFieldValue("razaoSocial", responseCliente.data.razaoSocial);
    }
  };

  const handleModalidadeComercializacaoChange = (e) => {
    formik.handleChange(e);

    if (e.target.value !== 1) {
      formik.setFieldValue("contrato", true);
    }

    formik.setFieldValue("modalidadeServico", 1);
  };

  async function loadVersoesAcesso(vertical) {
    try {
      const response = await api.get(`/Versao/versao-por-produto?tipoSistema=2&tipoVertical=${vertical || formik.values.vertical}`);

      setVersoesAcesso(response.data);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  }

  const handleContratoChange = (e) => {
    if (formik.values.modalidadeComercializacao === 2 || formik.values.vertical === 7) {
      formik.setFieldValue("contrato", true);
      return;
    }

    formik.handleChange(e);
  };

  useEffect(() => {
    if (!id || formik.values.statusPedido === null || !formik.values.dataLiberacao) return;

    async function fetchLastLicenca() {
      try {
        const { data } = await api.get(
          `/LicencaAcesso/parametros-consulta?id=${idDistribuidor}&nivel=${nivelUsuario}&tipo=ns&args=${formik.values.numeroSerie}`
        );

        const ordered = data.sort((a, b) => new Date(b.dataLiberacao) - new Date(a.dataLiberacao));

        let licenca = null;

        if (formik.values.statusPedido === 0) {
          licenca = ordered[0];
        } else if (formik.values.statusPedido > 0 && formik.values.dataLiberacao) {
          licenca = ordered.find((l) => new Date(l.dataLiberacao) < new Date(formik.values.dataLiberacao));
        }

        if (!licenca) return;

        setLastLicenca(licenca);
      } catch (e) {
        console.log(e);
      }
    }

    fetchLastLicenca();
  }, [id, formik.values.statusPedido]);

  useEffect(() => {
    api.get('/TipoServico/').then((r) => setTiposServico(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!id && formik.values.tipoServicoId === null && tipoServicoPadrao) {
      formik.setFieldValue("tipoServicoId", tipoServicoPadrao);
    }
  }, [id, tipoServicoPadrao]);

  useEffect(() => {
    if (formik.values.statusPedido === 0) {
      setPedidoLiberado(false);
    }
  }, []);

  useEffect(() => {
    const getClientes = async (id) => {
      if (!id) return;

      try {
        const { data } = await api.get(`/Cliente/${id}/A`);

        const registrosFiltrados = data
          .filter((cliente) => cliente.statusEmpresa === 1)
          .sort((a, b) => a.razaoSocial.localeCompare(b.razaoSocial));

        setClientes(registrosFiltrados);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    getClientes(formik.values.distribuidor);
  }, [formik.values.distribuidor]);

  useEffect(() => {
    if (selectedNS) atualizarLicencaPorNS();
  }, [selectedNS]);

  useEffect(() => {
    loadVersoesAcesso();
  }, [formik.values.vertical]);

  useEffect(() => {
    const loadData = async () => {
      if (!id) return;

      try {
        setIsLoading(true);
        const response = await api.get(`/BmaAcesso/${id}`);

        loadFields(response.data, true);
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [id]);

  useEffect(() => {
    if (formik.isSubmitting && Object.keys(formik.errors).length) {
      setMensagem("Preencha os campos obrigatórios.");
      setTipoMensagem("danger");
      setShowMensagem(true);
    }
  }, [formik.errors]);

  useEffect(() => {
    if (formik.submitCount === 0) return;
    const errorKeys = Object.keys(formik.errors);
    if (!errorKeys.length) return;
    const selector = errorKeys.map(name => `[name="${name}"]`).join(', ');
    const el = document.querySelector(selector);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.focus?.();
    }
  }, [formik.submitCount]);

  useEffect(() => {
    setDadosTabs({
      distribuidor: formik.values.distribuidor,
      cliente: formik.values.cliente,
      nomeFantasia: formik.values.nomeFantasia,
      numeroSerie: formik.values.numeroSerie,
      observacaoNotaFiscal: formik.values.observacaoNotaFiscal,
    });
  }, [formik.values.distribuidor, formik.values.cliente, formik.values.nomeFantasia, formik.values.numeroSerie, formik.values.observacaoNotaFiscal]);

  useEffect(() => {
    async function loadRevenda() {
      try {
        if (distribuidores.length === 0) {
          await getDistribuidores();
        } else if (distribuidores.length === 1) {
          formik.setFieldValue("distribuidor", distribuidores[0].id);
          setIsRevendaEnabled(false);
        }
      } catch (error) {
        console.error("Erro ao buscar distribuidores:", error);
      }
    }

    loadRevenda();
  }, [distribuidores]);

  if (isLoading) return <Loading />;

  return (
    <Box>
      {showMensagem && <Mensagem mensagem={mensagem} setMensagem={setMensagem} variant={tipoMensagem} />}
      {showModalNS && formik.values.tipoPedido === 1 && listaNS.length > 0 && (
        <ModalNS
          modalNS={showModalNS}
          setModalNS={setShowModalNS}
          numeroSerie={formik.values.numeroSerie}
          setNumeroSerie={(value) => formik.setFieldValue("numeroSerie", value)}
          titleModal={formik.values.nomeFantasia}
          listaNS={listaNS}
          setNSSelecionada={setSelectedNS}
        />
      )}

      {modalLiberacao.show && <ModalLiberacao pedido={modalLiberacao.pedido} />}

      <Container sx={{ py: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <Tabs
            sx={{ backgroundColor: "#f5f5f5", boxShadow: "0 -1px 4px 1px rgba(0, 0, 0, 0.1)" }}
            value={value}
            onChange={handleTabChange}
            aria-label="basic tabs example"
          >
            <Tab label="Pedido" {...tabProps(0)} />
            <Tab label="Contrato" {...tabProps(1)} disabled={!formik.values.contrato || !id} />
            <Tab label="Serviço" {...tabProps(2)} disabled={!id} />
          </Tabs>
          <Typography component="h1" variant="h5" sx={{ margin: "0.6rem 13%", fontWeight: 400, color: "#a3a3a3" }}>
            Pedido - Acesso
          </Typography>
        </Box>
        <Box>
          <Paper sx={{ backgroundColor: "#F7F8F8", width: "70rem" }} elevation={3}>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ width: "100%", display: "flex", justifyContent: "end", pr: 1 }}>
                {isShow && formik.values.statusPedido === 0 && (
                  <Button
                    variant="text"
                    startIcon={<DriveFolderUploadIcon />}
                    color="success"
                    onClick={() =>
                      setModalLiberacao({
                        show: true,
                        pedido: {
                          id: id,
                          cliente: { razaoSocial: formik.values.razaoSocial, numeroInscricao: formik.values.numeroInscricao },
                          contrato: formik.values.contrato,
                          tipoInstalacao: formik.values.tipoPlano,
                        },
                      })
                    }
                    disabled={nivelUsuario !== "1" || pedidoLiberado}
                  >
                    Liberar Pedido
                  </Button>
                )}
                {isShow && formik.values.statusPedido === 0 && (nivelUsuario === "1" || nivelUsuario === "3") && (
                  <Tooltip title="Editar">
                    <IconButton onClick={() => navigate(`/pedidoacesso/${id}`)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <Box component="form" onSubmit={formik.handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <FormSectionBox>
                  <FormSectionTitle label="Dados do Pedido" />
                  <Container sx={{ display: "flex", flexDirection: "column", my: 3, justifyContent: "center" }}>
                    <BoxBase>
                      <FormControlBase>
                        <Box display="flex" alignItems="center">
                          <TextFieldBase
                            label="Número de Série"
                            name="numeroSerie"
                            value={formik.values.numeroSerie}
                            onChange={formik.handleChange}
                            onBlur={() => atualizarLicencaPorNS(true)}
                            error={formik.touched.numeroSerie && Boolean(formik.errors.numeroSerie)}
                            helperText={formik.touched.numeroSerie && formik.errors.numeroSerie}
                            width="20rem"
                            textAlign="center"
                            disabled={isShow}
                          />
                          <Tooltip title="Para licenças novas, o Número de Série deve ser 0" arrow>
                            <InfoOutlinedIcon
                              sx={{
                                ml: -4,
                                zIndex: 2,
                                color: "gray",
                                opacity: 0.6,
                                fontSize: 18,
                                cursor: "default",
                                cursor: "pointer",
                                ":hover": { opacity: 0.9 },
                              }}
                            />
                          </Tooltip>
                        </Box>

                        <ButtonBase
                          variant="contained"
                          onClick={() => handleSelecionarNS()}
                          sx={{ marginLeft: 1.7, width: "10rem", fontSize: "0.75rem", maxHeight: "3.5rem" }}
                          disabled={!formik.values.cliente || formik.values.quantidadeLicencas === 0 || isShow}
                        >
                          Selecionar NS
                        </ButtonBase>
                      </FormControlBase>
                    </BoxBase>
                    <BoxBase>
                      <FormControlBase>
                        <InputLabelSelect id="distribuidor">Revenda</InputLabelSelect>
                        <SelectBase
                          id="distribuidor"
                          label="Revenda"
                          name="distribuidor"
                          value={formik.values.distribuidor}
                          onChange={(e) => handleDistribuidorChange(e)}
                          onBlur={formik.handleBlur}
                          error={formik.touched.distribuidor && Boolean(formik.errors.distribuidor)}
                          helperText={formik.touched.distribuidor && formik.errors.distribuidor}
                          isShow={isShow || !isRevendaEnabled}
                          width="20rem"
                        >
                          {distribuidores.map((distribuidor) => (
                            <MenuItem key={distribuidor.id} value={distribuidor.id}>
                              {distribuidor.razaoSocial}
                            </MenuItem>
                          ))}
                        </SelectBase>
                      </FormControlBase>
                      <FormControlBase>
                        <InputLabelSelect id="cliente">Cliente</InputLabelSelect>
                        <SelectBase
                          id="cliente"
                          label="Cliente"
                          name="cliente"
                          value={formik.values.cliente}
                          onChange={(e) => handleClienteChange(e)}
                          onBlur={formik.handleBlur}
                          error={formik.touched.cliente && Boolean(formik.errors.cliente)}
                          helperText={formik.touched.cliente && formik.errors.cliente}
                          isShow={isShow}
                          width="21.5rem"
                        >
                          {clientes.map((cliente) => (
                            <MenuItem key={cliente.id} value={cliente.id}>
                              {cliente.razaoSocial} - {cliente.numeroInscricao}
                            </MenuItem>
                          ))}
                        </SelectBase>
                      </FormControlBase>

                      <FormControlBase>
                        <TextFieldBase label="Nome Fantasia" name="nomeFantasia" value={formik.values.nomeFantasia} width="20rem" disabled />
                      </FormControlBase>
                    </BoxBase>

                    <FormControlBase sx={{ mb: 2 }}>
                      <InputLabelSelect id="tipoServicoId">Tipo de Serviço</InputLabelSelect>
                      <SelectBase
                        id="tipoServicoId"
                        label="Tipo de Serviço"
                        name="tipoServicoId"
                        value={formik.values.tipoServicoId}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.tipoServicoId && Boolean(formik.errors.tipoServicoId)}
                        helperText={formik.touched.tipoServicoId && formik.errors.tipoServicoId}
                        isShow={isShow}
                        width="100%"
                      >
                        {tiposServico.map((tipo) => (
                          <MenuItem key={tipo.id} value={tipo.id}>
                            {tipo.tituloTipo}
                          </MenuItem>
                        ))}
                      </SelectBase>
                    </FormControlBase>

                    <FormControlBase sx={{ mb: 2 }}>
                      <TextFieldBase
                        label="Observações"
                        name="observacoes"
                        value={formik.values.observacoes}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.observacoes && Boolean(formik.errors.observacoes)}
                        helperText={formik.touched.observacoes && formik.errors.observacoes}
                        width="100%"
                        multiline
                        rows={4}
                        disabled={isShow}
                      />
                    </FormControlBase>

                    <FormControlBase sx={{ mb: 2 }}>
                      <TextFieldBase
                        label="Observação Nota Fiscal"
                        name="observacaoNotaFiscal"
                        value={formik.values.observacaoNotaFiscal}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.observacaoNotaFiscal && Boolean(formik.errors.observacaoNotaFiscal)}
                        helperText={formik.touched.observacaoNotaFiscal && formik.errors.observacaoNotaFiscal}
                        width="100%"
                        multiline
                        rows={3}
                        disabled={isShow}
                      />
                    </FormControlBase>

                    {(formik.values.statusPedido === 2 || formik.values.dataCancelamento !== null) && (
                      <>
                        <br />
                        <BoxBase>
                          <FormControlBase>
                            <TextFieldBase
                              label="Data do Cancelamento"
                              name="dataCancelamento"
                              value={formik.values.dataCancelamento}
                              type="date"
                              onChange={formik.handleChange}
                              onBlur={formik.onBlur}
                              error={formik.touched.dataCancelamento && Boolean(formik.errors.dataCancelamento)}
                              helperText={formik.touched.dataCancelamento && formik.errors.dataCancelamento}
                              width="20rem"
                              disabled={isShow}
                            />
                          </FormControlBase>

                          <FormControlBase>
                            <InputLabelSelect id="motivoCancelamentoOpcao">Motivo do Cancelamento</InputLabelSelect>
                            <SelectBase
                              id="motivoCancelamentoOpcao"
                              name="motivoCancelamentoOpcao"
                              disabled={isShow}
                              onChange={formik.handleChange}
                              onBlur={formik.onBlur}
                              error={formik.touched.motivoCancelamentoOpcao && Boolean(formik.errors.motivoCancelamentoOpcao)}
                              helperText={formik.touched.motivoCancelamentoOpcao && formik.errors.motivoCancelamentoOpcao}
                              label="Motivo do Cancelamento"
                              value={formik.values.motivoCancelamentoOpcao}
                              width="41rem"
                              margin="0 0 0 -5px"
                            >
                              {motivosCancelamento.map((motivo) => (
                                <MenuItem key={motivo.id} value={motivo.id}>
                                  {motivo.descricaoMotivo}
                                </MenuItem>
                              ))}
                            </SelectBase>
                          </FormControlBase>
                        </BoxBase>

                        <br />

                        <FormControlBase>
                          <TextFieldBase
                            label="Detalhes do Cancelamento"
                            name="motivoCancelamento"
                            onChange={formik.handleChange}
                            onBlur={formik.onBlur}
                            error={formik.touched.motivoCancelamento && Boolean(formik.errors.motivoCancelamento)}
                            helperText={formik.touched.motivoCancelamento && formik.errors.motivoCancelamento}
                            value={formik.values.motivoCancelamento}
                            disabled={isShow}
                            width="100%"
                            multiline
                            rows={4}
                          />
                        </FormControlBase>
                      </>
                    )}
                  </Container>
                </FormSectionBox>

                <FormSectionBox>
                  <FormSectionTitle label="Dados da Licença" />
                  <Container sx={{ display: "flex", flexDirection: "column", my: 3 }}>
                    <BoxBase>
                      <FormControlBase>
                        <InputLabelSelect id="vertical">Vertical</InputLabelSelect>
                        <SelectBase
                          id="vertical"
                          label="Vertical"
                          name="vertical"
                          value={formik.values.vertical}
                          onChange={handleVerticalChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.vertical && Boolean(formik.errors.vertical)}
                          helperText={formik.touched.vertical && formik.errors.vertical}
                          width="32rem"
                          isShow={isShow}
                        >
                          <MenuItem value={1}>Empresa</MenuItem>
                          <MenuItem value={2}>Refeitório</MenuItem>
                          <MenuItem value={3}>Academia</MenuItem>
                          <MenuItem value={4}>Condomínio</MenuItem>
                          <MenuItem value={5}>Hospital</MenuItem>
                          <MenuItem value={6}>Escola</MenuItem>
                          <MenuItem value={7}>Acesso Go</MenuItem>
                        </SelectBase>
                      </FormControlBase>

                      <FormControlBase>
                        <TextFieldBase
                          select
                          id="versao"
                          name="versaoFormatada"
                          label="Versão"
                          value={formik.values.versaoFormatada}
                          onChange={(e) => handleVersaoChange(e)}
                          width="32rem"
                          textAlign="center"
                          disabled={nivelUsuario !== "1" || isShow}
                        >
                          {versoesAcesso.map((item) => {
                            return (
                              <MenuItem key={item.versaoCompletaEditada} value={item.versaoCompletaEditada}>
                                {item.versaoCompletaEditada}
                              </MenuItem>
                            );
                          })}
                        </TextFieldBase>
                      </FormControlBase>
                    </BoxBase>

                    <BoxBase justifyContent={"flex-start"}>
                      <FormControlBase>
                        <InputLabelSelect id="modalidadeComercializacao">Modalidade de Comercialização</InputLabelSelect>
                        <SelectBase
                          id="modalidadeComercializacao"
                          label="Modalidade de Comercialização"
                          name="modalidadeComercializacao"
                          value={formik.values.modalidadeComercializacao}
                          onChange={handleModalidadeComercializacaoChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.modalidadeComercializacao && Boolean(formik.errors.modalidadeComercializacao)}
                          helperText={formik.touched.modalidadeComercializacao && formik.errors.modalidadeComercializacao}
                          width="32rem"
                          isShow={isShow || isModComercializacaoDisabled}
                        >
                          {isShow && formik.values.modalidadeComercializacao === 1 && formik.values.tipoLicenciamento !== 1 && (
                            <MenuItem value={1}>Licenciado</MenuItem>
                          )}
                          {isShow && formik.values.modalidadeComercializacao === 1 && formik.values.tipoLicenciamento === 1 && (
                            <MenuItem value={1}>Licenciamento Anual</MenuItem>
                          )}
                          <MenuItem value={2}>Locação</MenuItem>
                        </SelectBase>
                      </FormControlBase>

                      <FormControlBase margin={"0 0 0 -1.5rem"}>
                        <InputLabelSelect id="modalidadeServico">Modalidade de Serviço</InputLabelSelect>
                        <SelectBase
                          id="modalidadeServico"
                          label="Modalidade de Serviço"
                          name="modalidadeServico"
                          value={formik.values.modalidadeServico}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.modalidadeServico && Boolean(formik.errors.modalidadeServico)}
                          helperText={formik.touched.modalidadeServico && formik.errors.modalidadeServico}
                          width="30.5rem"
                          isShow={isShow || isModServicoDisabledAcessoGo}
                        >
                          <MenuItem value={1}>On Premisse</MenuItem>
                        </SelectBase>
                      </FormControlBase>
                    </BoxBase>

                    <BoxBase justifyContent={"flex-start"}>
                      <FormControlBase>
                        <InputLabelSelect id="bancoDeDados">Banco de Dados</InputLabelSelect>
                        <SelectBase
                          id="bancoDeDados"
                          label="Banco de Dados"
                          name="bancoDeDados"
                          value={formik.values.bancoDeDados}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.bancoDeDados && Boolean(formik.errors.bancoDeDados)}
                          helperText={formik.touched.bancoDeDados && formik.errors.bancoDeDados}
                          isShow={isShow}
                          width="32rem"
                        >
                          <MenuItem value={1}>MySql</MenuItem>
                          <MenuItem value={2}>SqlServer</MenuItem>
                          <MenuItem value={3}>Oracle</MenuItem>
                        </SelectBase>
                      </FormControlBase>

                      {nivelUsuario === "1" && (
                        <FormControlBase>
                          <TextFieldBase
                            label="Data de Validade"
                            name="dataValidade"
                            value={formik.values.dataValidade}
                            type="date"
                            onChange={formik.handleChange}
                            onBlur={formik.onBlur}
                            error={formik.touched.dataValidade && Boolean(formik.errors.dataValidade)}
                            helperText={formik.touched.dataValidade && formik.errors.dataValidade}
                            width="32rem"
                            disabled={isShow}
                          />
                        </FormControlBase>
                      )}
                    </BoxBase>

                    <BoxBase>
                      <FormControl>
                        <TextFieldBase
                          label="Server Adicional"
                          name="serverAdicional"
                          value={formik.values.serverAdicional}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.serverAdicional && Boolean(formik.errors.serverAdicional)}
                          helperText={formik.touched.serverAdicional && formik.errors.serverAdicional}
                          width={"20rem"}
                          disabled={isShow || isAdicionaisDisabled}
                          textAlign="center"
                        />
                      </FormControl>

                      <FormControlBase>
                        <TextFieldBase
                          id="equipamentosAdicionais"
                          label="Equipamentos Adicionais"
                          name="equipamentosAdicionais"
                          value={formik.values.equipamentosAdicionais}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.equipamentosAdicionais && Boolean(formik.errors.equipamentosAdicionais)}
                          helperText={formik.touched.equipamentosAdicionais && formik.errors.equipamentosAdicionais}
                          width={"24rem"}
                          marginLeft={"1.2rem"}
                          disabled={isShow}
                          textAlign="center"
                        />
                      </FormControlBase>

                      <FormControlBase>
                        <TextFieldBase
                          label="Usuários Agenda"
                          name="usuariosAgenda"
                          value={formik.values.usuariosAgenda}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.touched.usuariosAgenda && Boolean(formik.errors.usuariosAgenda)}
                          helperText={formik.touched.usuariosAgenda && formik.errors.usuariosAgenda}
                          width={"21.3rem"}
                          marginLeft={"-0.8rem"}
                          disabled={isShow || isAdicionaisDisabled}
                          textAlign="center"
                        />
                      </FormControlBase>
                    </BoxBase>

                    <FormikProvider value={formik}>
                      <Grid container spacing={2} sx={{ pb: 2, pl: 4, mt: 1, display: "flex" }}>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="contrato"
                            checked={formik.values.contrato}
                            onChange={handleContratoChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Contrato"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="moduloLGPD"
                            checked={formik.values.moduloLGPD}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Módulo LGPD"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="portalTerceiros"
                            checked={formik.values.portalTerceiros}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Portal Terceiros"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="portalTreinamento"
                            checked={formik.values.portalTreinamento}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Portal de Treinamento"
                          />
                        </Grid>
                      </Grid>
                      <Typography
                        variant="overline"
                        sx={{ ml: 4, mt: 0.2, mb: 2, borderBottom: "1px solid rgb(19, 35, 80)", textAlign: "center" }}
                      >
                        Integrações
                      </Typography>
                      <Grid container spacing={2} sx={{ pb: 2, pl: 4, display: "flex" }}>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="alunos"
                            checked={formik.values.alunos}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Alunos"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="funcionarios"
                            checked={formik.values.funcionarios}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Funcionários"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <CheckboxBase
                            name="pacientes"
                            checked={formik.values.pacientes}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Pacientes"
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <CheckboxBase
                            name="ponto"
                            checked={formik.values.ponto}
                            onChange={formik.handleChange}
                            disabled={isShow || isCheckboxDisabled}
                            label="Ponto"
                          />
                        </Grid>

                        <Grid item xs={4}>
                          <CheckboxBase checked={formik.values.pontoSaas === 1} disabled label="BMA Ponto SaaS via API" />
                        </Grid>
                      </Grid>
                    </FormikProvider>
                  </Container>
                </FormSectionBox>

                {lastLicenca?.id && <LicencaSection licenca={lastLicenca} dataPedido={formik.values.dataPedido} />}

                <FormSectionBox>
                  <FormSectionTitle label="Totais" />
                  <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
                    <Grid container spacing={2} sx={{ pt: 2, pb: 4, px: 4 }}>
                      <Grid item xs={3}>
                        <FormControl>
                          <CurrencyInput
                            customInput={TextFieldBase}
                            label="Valor da Licença Mensal"
                            name="valorLicenca"
                            value={formik.values.valorLicenca}
                            onValueChange={(value) => formik.setFieldValue("valorLicenca", value)}
                            onBlur={formik.handleBlur}
                            intlConfig={{ locale: "pt-BR", currency: "BRL" }}
                            disabled={nivelUsuario !== "1" || isShow}
                            textAlign="center"
                            decimalScale={2}
                            decimalsLimit={2}
                            mb={1.5}
                          />
                          <CurrencyInput
                            customInput={TextFieldBase}
                            label="Valor Módulo LGPD"
                            name="valorModuloLGPD"
                            value={formik.values.valorModuloLGPD}
                            onValueChange={(value) => formik.setFieldValue("valorModuloLGPD", value)}
                            onBlur={formik.handleBlur}
                            intlConfig={{ locale: "pt-BR", currency: "BRL" }}
                            disabled={nivelUsuario !== "1" || isShow}
                            textAlign="center"
                            decimalScale={2}
                            decimalsLimit={2}
                            mb={1.5}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl>
                          <CurrencyInput
                            customInput={TextFieldBase}
                            label="Valor Equip. Adicional"
                            name="valorEquipAdicional"
                            value={formik.values.valorEquipAdicional}
                            onValueChange={(value) => formik.setFieldValue("valorEquipAdicional", value)}
                            onBlur={formik.handleBlur}
                            intlConfig={{ locale: "pt-BR", currency: "BRL" }}
                            disabled={nivelUsuario !== "1" || isShow}
                            textAlign="center"
                            decimalScale={2}
                            decimalsLimit={2}
                            mb={1.5}
                          />
                          <CurrencyInput
                            customInput={TextFieldBase}
                            label="Valor Server Adicional"
                            name="valorServerAdicional"
                            value={formik.values.valorServerAdicional}
                            onValueChange={(value) => formik.setFieldValue("valorServerAdicional", value)}
                            onBlur={formik.handleBlur}
                            intlConfig={{ locale: "pt-BR", currency: "BRL" }}
                            disabled={nivelUsuario !== "1" || isShow}
                            textAlign="center"
                            decimalScale={2}
                            decimalsLimit={2}
                            mb={1.5}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={3}>
                        <FormControl>
                          <CurrencyInput
                            customInput={TextFieldBase}
                            label="Valor Módulos e Integrações"
                            name="valorModulosIntegracoes"
                            value={formik.values.valorModulosIntegracoes}
                            onValueChange={(value) => formik.setFieldValue("valorModulosIntegracoes", value)}
                            onBlur={formik.handleBlur}
                            intlConfig={{ locale: "pt-BR", currency: "BRL" }}
                            disabled={nivelUsuario !== "1" || isShow}
                            textAlign="center"
                            decimalScale={2}
                            decimalsLimit={2}
                            mb={1.5}
                          />
                          <CurrencyInput
                            customInput={TextFieldBase}
                            label="Valor Mensal"
                            name="valorMensal"
                            value={formik.values.valorMensal}
                            onValueChange={(value) => formik.setFieldValue("valorMensal", value)}
                            onBlur={formik.handleBlur}
                            intlConfig={{ locale: "pt-BR", currency: "BRL" }}
                            disabled={nivelUsuario !== "1" || isShow}
                            textAlign="center"
                            decimalScale={2}
                            decimalsLimit={2}
                            mb={1.5}
                          />
                          {nivelUsuario === "1" && formik.values.tipoPedido === 1 && (
                            <TextFieldBase
                              label="Diferença vs Última Licença"
                              value={valorDiferencaMensal}
                              width="20rem"
                              disabled
                              sx={{ mt: 1.5 }}
                            />
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={3} sx={{ display: "flex", justifyContent: "center", alignItems: "end", pb: 2 }}>
                        <ButtonBase variant="outlined" onClick={() => handleVerificarTotaisClick()} startIcon={<AttachMoneyIcon />} disabled={isShow}>
                          Verificar Totais
                        </ButtonBase>
                      </Grid>
                    </Grid>
                  </Box>
                </FormSectionBox>
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
                  {isShow || formik.values.tipoPedido === 2 ? (
                    <ButtonBase variant="outlined" onClick={() => navigate("/pedidos")}>
                      Voltar
                    </ButtonBase>
                  ) : (
                    <>
                      <ButtonBase variant="outlined" onClick={() => navigate("/pedidos")}>
                        Cancelar
                      </ButtonBase>
                      <ButtonBase type="submit" variant="contained" disabled={!isSaveEnabled || isSaving}>
                        Salvar
                      </ButtonBase>
                    </>
                  )}
                </Box>
              </Box>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <ContratoTab isShow={isShow} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <ServicoTab isShow={isShow || nivelUsuario !== "1"} />
            </CustomTabPanel>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}
